import UiAction from "./index";

// if this is for creating many info post ui
// at app/views/sub_pages/_sub_form.html.slim
$(() => {
  if ($("#info_posts").length > 0) {
    const currentInfoPosts = $(".main_ui_actions").map((_, element) => {
      return new UiAction(
        element,
        ".main_ui_action_radio_buttons",
        ".main_ui_action_items",
        {
          isSubPageRequired: false,
          isSubPage: false,
        },
        {
          hasCallToAction: true,
          hasSubPage: false,
        }
      );
    });

    currentInfoPosts.each((_, uiAction) => uiAction.attach());

    // for info posts
    $("#info_posts").on(
      "cocoon:after-insert",
      (e, insertedItem, originalEvent) => {
        const uiActionPanel = $(insertedItem).find(".main_ui_actions");
        const newInfoPost = new UiAction(
          uiActionPanel,
          ".main_ui_action_radio_buttons",
          ".main_ui_action_items",
          {
            isSubPageRequired: false,
            isSubPage: false,
          },
          {
            hasCallToAction: true,
            hasSubPage: false,
          }
        );
        newInfoPost.attach();
      }
    );
  }
});
